import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import SignUp from './components/SignUp';
import TradingDashboard from './components/TradingDashboard';
import TradingConfig from './components/TradingConfig';
import Membership from './components/Membership';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/membership" element={<Membership />} />
        
        {/* Protected routes */}
        <Route path="/dashboard" element={<TradingDashboard />} />
        <Route path="/trading-config" element={<TradingConfig />} />
        
        {/* Catch all route - redirect to landing page */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;